import { useContext } from 'react';
import { CardSelectorContext } from './CardSelector';

export function useCardSelector() {
  const context = useContext(CardSelectorContext);

  if (!context) {
    // Return default no-op functions when context is not available (e.g., readOnly mode)
    return {
      selectedCards: [],
      setSelectedCards: () => {},
      toggle: () => {},
      checkIsActive: () => false,
      checkIsEnable: () => true,
      clearSelection: () => {},
    };
  }

  return context;
}
